<template>
  <div>
    <myheader
      :backFlag="flowStep !== 1"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="个人实名认证"
    ></myheader>
    <div class="header_extend_main">
      <div class="header_extend_back"></div>
      <div v-if="flowStep == 0">
        <div class="header_extend_content" style="padding-bottom: 5rem">
          <div class="all_tips_content_card_padding5">
            <div class="display_flex">
              <span
                class="text12 textcolor999 font_weight_bold all_tips_red_after"
                >请填写本人身份信息</span
              >
              <span style="margin-left: 1rem" class="display_flex">
                <img
                  src="@/assets/images/tanhao.svg"
                  style="width: 0.7rem; height: 0.7rem"
                />
              </span>
              <span class="text10 textcolor999" style="margin-left: 0.2rem"
                >仅支持中国大陆居民身份证</span
              >
            </div>
            <div class="text14 textcolor666 margin_top_5">身份证姓名</div>
            <div class="all_van_field" :class="{ isfocus: nameFocus }">
              <van-field
                v-model="staffName"
                type="text"
                maxlength="30"
                placeholder="请输入本人真实姓名"
                clearable
                @focus="getFocus(1)"
                @blur="onblur(1)"
              >
              </van-field>
            </div>
            <div class="text14 textcolor666 margin_top_5">身份证号码</div>
            <div class="all_van_field" :class="{ isfocus: idcodeFocus }">
              <van-field
                v-model="idCode"
                type="text"
                maxlength="18"
                placeholder="请输入本人身份证号码"
                clearable
                @focus="getFocus(2)"
                @blur="onblur(2)"
              >
              </van-field>
            </div>
          </div>
          <div class="all_tips_content_card_padding5 margin_top_10">
            <div
              class="text12 textcolor999 font_weight_bold all_tips_red_after"
            >
              请选择个人实名认证方式
            </div>
            <div class="text14 textcolor666 margin_top_5">认证方式</div>
            <div class="all_tips_input display_flex">
              <div
                class="width_flex all_height_line16 text14 textcolor333 font_weight_900"
              >
                {{ authStyleText }}
              </div>
              <div
                class="selectstyle all_height_line16 text14 textcolor333 font_weight_900 display_flex"
                @click="showBottom = true"
              >
                更换方式
              </div>
            </div>
            <div class="text10 textcolor999">{{ authStyleTips }}</div>
            <div v-show="authStyle !== 3">
              <div
                v-show="authStyle === 5"
                class="text14 textcolor666 margin_top_5"
              >
                银行卡号
              </div>
              <div
                v-show="authStyle === 5"
                class="all_van_field"
                :class="{ isfocus: backnuFocus }"
              >
                <van-field
                  v-model="backNumber"
                  type="number"
                  placeholder="银行卡号"
                  clearable
                  @focus="getFocus(3)"
                  @blur="onblur(3)"
                >
                </van-field>
              </div>
              <div class="text14 textcolor666 margin_top_5">
                {{ authStyle === 2 ? "预留手机号" : "手机号" }}
              </div>
              <div class="all_van_field" :class="{ isfocus: phoneFocus }">
                <van-field
                  v-model="phone"
                  type="number"
                  maxlength="11"
                  placeholder="请输入手机号"
                  clearable
                  @focus="getFocus(4)"
                  @blur="onblur(4)"
                >
                </van-field>
              </div>
              <div class="text14 textcolor666 margin_top_5">图形验证码</div>
              <div class="all_tips_input" :class="{ isfocus: verifyFocus }">
                <div class="display_inline_block" style="width: 65%">
                  <van-field
                    v-model="verifyCode"
                    type="number"
                    maxlength="6"
                    placeholder="请输入验证码"
                    clearable
                    @focus="getFocus(5)"
                    @blur="onblur(5)"
                  />
                </div>
                <span
                  @click="getPictureImg()"
                  class="display_inline_block"
                  title="看不清,换一个"
                  style="width: 35%"
                >
                  <img
                    :src="verifyImg"
                    style="height: 1.8rem; width: 5rem"
                    fill
                    title="看不清,换一个"
                /></span>
              </div>
              <div class="text14 textcolor666 margin_top_5">验证码</div>
              <div
                id="bottom"
                class="all_tips_input"
                :class="{ isfocus: smscodeFocus }"
              >
                <div class="display_inline_block" style="width: 60%">
                  <van-field
                    v-model="smscode"
                    type="number"
                    maxlength="6"
                    placeholder="请输入验证码"
                    clearable
                    @focus="getFocus(6)"
                    @blur="onblur(6)"
                    @keydown.enter="next()"
                  />
                </div>
                <span
                  @click="getCode()"
                  class="display_inline_block text14 all_text_right all_line_height20"
                  style="width: 35%"
                  :class="{
                    textcolormain: timer === 60,
                    textcolor999: timer != 60,
                  }"
                >
                  {{
                    timer === 60 ? "获取验证码" : timer + "s后再次获取"
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="flowStep == 1">
        <div class="header_extend_content">
          <div class="all_tips_content_card">
            <div style="width: 100%; text-align: center; padding: 1rem 0">
              <img
                style="width: 4rem; height: 4rem; margin: 0.2rem"
                src="@/assets/images/selected.svg"
                @click="showBottom = true"
              />
              <div class="text12 textcolor999 margin_top_2">认证完成</div>
              <div class="text14 textcolor666 margin_top_2">
                您已完成个人认证
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="buttonShow" class="all_tips_bottom_card">
        <van-checkbox
          v-if="flowStep == 0"
          class="text12 textcolor333"
          v-model="checked"
          >我已阅读并同意
          <span class="textcolormain" @click="agreementClick()"
            >《实名认证服务协议》</span
          ></van-checkbox
        >
        <button
          class="all_button22 width_100 text16 bmain_active margin_top_5"
          @click="next()"
        >
          {{
            flowStep == 1
              ? "完&nbsp;&nbsp;成"
              : authStyle === 3
              ? "下一步"
              : "提交"
          }}
        </button>
      </div>
    </div>
    <van-popup v-model:show="showBottom" position="bottom">
      <div class="selectStyleList">
        <div class="horizontal_line"></div>
        <div
          class="style backgroundC_white bwhite_ative display_flex"
          @click="selectAuthStyle(4)"
        >
          <img
            style="height: 3rem; margin: 0.5rem 0.8rem"
            src="@/assets/images/phone_auth.svg"
          />
          <div class="display_inline_block" style="flex: 1">
            <div class="all_height_line20 text14 textcolor333 font_weight_900">
              实名手机号认证
            </div>
            <div class="text12 textcolor999">
              填写个人实名手机号进行个人实名认证
            </div>
          </div>
        </div>
        <div class="horizontal_line"></div>
        <div
          class="style backgroundC_white bwhite_ative display_flex"
          @click="selectAuthStyle(5)"
        >
          <img
            style="height: 3rem; margin: 0.5rem 0.8rem"
            src="@/assets/images/bank_auth.svg"
          />
          <div class="display_inline_block" style="flex: 1">
            <div class="all_height_line20 text14 textcolor333 font_weight_900">
              个人银行卡认证
            </div>
            <div class="text12 textcolor999">
              填写银行卡号与银行卡预留手机号进行个人实名认证
            </div>
          </div>
        </div>
        <div class="horizontal_line"></div>
        <div
          class="style backgroundC_white bwhite_ative display_flex"
          @click="selectAuthStyle(3)"
        >
          <img
            style="height: 3rem; margin: 0.5rem 0.8rem"
            src="@/assets/images/bank_auth.svg"
          />
          <div class="display_inline_block" style="flex: 1">
            <div class="all_height_line20 text14 textcolor333 font_weight_900">
              人脸识别认证
            </div>
            <div class="text12 textcolor999">通过人脸识别进行个人实名认证</div>
          </div>
        </div>
        <div class="horizontal_line"></div>
        <div style="height: 0.5rem; background-color: #ededed"></div>
        <div class="horizontal_line"></div>
        <div
          class="all_height_line24 text14 textcolor999 all_text_center"
          @click="showBottom = false"
        >
          取&nbsp;消
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  realLiveAuth,
  initIosAuth
} from '../../../utils/nativeRealLiveAuth.js';
import {
  closeCurrentPage
} from '../../../utils/nativeOtherOperate.js'
import {
  getUserInfo
} from '../../../utils/shareRequest.js'
import Vue from 'vue';
import {
  Checkbox,
  Field,
  Icon
} from 'vant';
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Icon.name]: Icon,
  },
  data() {
    return {
      authInfo: '',
      //0 输入姓名  1 输入手机号验证码  2验证结果
      flowStep: 0,
      nameFocus: false,
      idcodeFocus: false,
      //勾选协议
      checked: false,
      //姓名
      staffName: '',
      //身份证号
      idCode: '',
      //验证码倒计时
      timer: 60,
      backnuFocus: false,
      phoneFocus: false,
      verifyFocus: false,
      smscodeFocus: false,
      // 认证方式  3人脸识别 4手机认证 5银行卡认证
      authStyle: 3,
      // 认证方式 实名手机号认证 个人银行卡认证 人脸识别认证
      authStyleText: '实名手机号认证',
      authStyleTips: '与运营商手机号实名信息对比验证，请确保手机号已通过运营商实名认证',
      //银行卡号
      backNumber: '',
      //电话号码
      phone: '',
      //图片验证结果
      verifyCode: '',
      //验证Id
      verifyId: '',
      //验证图片
      verifyImg: '',
      //验证码
      smscode: '',
      //
      showBottom: false,
      //
      buttonShow: true,
      clientHeight: 0,
      //人脸验证requestId
      requestId: '',
      //实人认证是否上传结果
      // canNotify: false,
      // //原生工具类
      // tool: null,
    }
  },
  methods: {
    //
    getBackFlag() {
      let backFlag = true
      if ((this.flowStep === 0 && this.$store.state.sourceFlag) || this.flowStep === 1) {
        backFlag = false
      }
      return backFlag
    },
    //获取认证图片
    getPictureImg() {
      this.verifyCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/login/api/getPictureImg').then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.verifyId = res.data.verifyId
          this.verifyImg = res.data.srcImg
        } else {
          this.verifyImg = ''
          this.$Toast("未获取到验证图片！");
        }
      }).catch((err) => {
        this.verifyImg = ''
        this.$store.dispatch(this.$LoadShow, false)
        console.log('getPictureImg', err)
      });
    },
    // 获取验证码
    getCode() {
      if (this.timer != 60) {
        return
      }
      this.phone = this.phone.trim()
      let reg = /^1[0-9]{10}$/;
      if (
        this.phone &&
        this.phone.length == 11 &&
        reg.test(this.phone)
      ) {
        if (!this.verifyCode || !this.verifyId) {
          this.$Toast("请输入图形验证码！");
          return
        }
        this.smscode = "";
        this.$store.dispatch(this.$LoadShow, true)
        this.$post("/staff/api/sendSmsCode", {
          mobile: this.phone,
          type: 5, //type：1 登录、2 忘记密码、3 重置密码、4 更换手机号、5 个人认证
          verify: {
            id: this.verifyId,
            code: this.verifyCode
          }
        }).then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success) {
            this.$Toast("验证码已发送，请注意查收！");
            //this.smscode = res.data;
            this.timer--;
            var timer1 = setInterval(() => {
              this.timer--;
              if (this.timer == 0) {
                this.timer = 60;
                clearTimeout(timer1);
              }
            }, 1000);
          } else {
            this.$Toast(res.message || "获取验证码失败！");
            this.getPictureImg()
          }
        }).catch(err => {
          this.$store.dispatch(this.$LoadShow, false)
          this.getPictureImg()
        })
      } else {
        this.$Toast("请输入正确的手机号！");
      }
    },
    // 实人认证成功
    faceAuthSucced(requestId) {
      this.requestId = requestId;
      this.saveAuthInfo();
    },
    // 实人认证失败
    faceAuthFaild(message) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(message || "认证失败！");
    },
    // 保存认证信息
    saveAuthInfo() {
      let data = ''
      switch (this.authStyle) {
        case 3:
          if (!this.requestId) {
            this.$Toast("认证失败！");
            return
          }
          data = {
            certifyWay: this.authStyle,
            certifyWayText: this.authStyleText,
            idCode: this.idCode,
            idType: this.authInfo.idType,
            idTypeText: this.authInfo.idTypeText,
            staffId: this.authInfo.staffId,
            staffName: this.staffName,
            faceModel: {
              certifyTime: this.Tool.getDataISOString(new Date().toISOString()),
              faceRequestId: this.requestId
            }
          }
          break;
        case 4:
          this.phone = this.phone.trim()
          this.smscode = this.smscode.trim()
          const phoneReg = /^1[0-9]{10}$/
          if (this.phone && this.phone.length == 11 && phoneReg.test(this.phone)) {
            if (!this.smscode) {
              this.$Toast('请输入验证码！')
              return
            }
            data = {
              certifyWay: this.authStyle,
              certifyWayText: this.authStyleText,
              idCode: this.idCode,
              idType: this.authInfo.idType,
              idTypeText: this.authInfo.idTypeText,
              staffId: this.authInfo.staffId,
              staffName: this.staffName,
              mobileModel: {
                mobile: this.phone,
                smsCode: this.smscode
              }
            }
          } else {
            this.$Toast('请输入正确的手机号码！')
          }
          break;
        case 5:
          this.phone = this.phone.trim()
          this.backNumber = this.backNumber.trim()
          this.smscode = this.smscode.trim()
          const phonesReg = /^1[0-9]{10}$/
          if (this.phone && this.phone.length == 11 && phonesReg.test(this.phone)) {
            if (!this.smscode) {
              this.$Toast('请输入验证码！')
              return
            }
            const bankReg = /^([1-9]{1})(\d{15}|\d{18})$/
            if (this.backNumber && bankReg.test(this.backNumber)) {
              data = {
                certifyWay: this.authStyle,
                certifyWayText: this.authStyleText,
                idCode: this.idCode,
                idType: this.authInfo.idType,
                idTypeText: this.authInfo.idTypeText,
                staffId: this.authInfo.staffId,
                staffName: this.staffName,
                bankModel: {
                  bankAccount: this.backNumber,
                  bankMobile: this.phone,
                  smsCode: this.smscode
                }
              }
            } else {
              this.$Toast('请输入正确的银行卡号！')
            }
          } else {
            this.$Toast('请输入正确的手机号码！')
          }
          break;
      }
      this.$store.dispatch(this.$LoadShow, true)
      this.$post("/staff/api/submitStaffApply", data)
        .then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success) {
            this.flowStep = 1
          } else {
            this.$Toast(res.message || res.messageDetail || '认证失败，请重新认证！')
            this.getPictureImg()
          }
        }).catch(err => {
          this.$Toast('认证失败，请重新认证！')
          this.$store.dispatch(this.$LoadShow, false)
          this.getPictureImg()
        })
    },
    //第一次：初始化、发验证码、提交；重新认证：编辑、发验证码、提交
    //个人认证初始化或认证编辑
    getAuthInfo() {
      if (this.switchAuthStatus()) {
        return
      }
      //默认调用初始化接口
      let url = '/staff/api/getNewStaffApply'
      let data = {}
      if (this.$store.state.userInfo && this.$store.state.userInfo.certifyState !== 0) {
        url = '/staff/api/getEditStaffApply'
        data = {
          staffId: this.$store.state.userInfo.staffId
        }
      }
      this.$get(url, data).then(res => {
        if (res.success && res.data) {
          this.authInfo = res.data
          this.selectAuthStyle(res.data.certifyWay)
        } else {
          this.$Toast(res.message || '获取认证信息失败，请重试！')
        }
      }).catch(err => {
        this.$Toast(err.message || '获取认证信息失败，请重试！')
      })
    },
    //更新个人信息身份证号和姓名
    saveStaffInfo(staffName, idCode) {
      const user = this.$store.state.userInfo
      const data = {
        staffName: staffName,
        idCode: idCode,
        gender: user.gender,
        staffCode: user.staffCode,
        userName: user.userName,
        staffType: user.staffType,
        mobile: user.mobile,
      }
      this.$store.dispatch(this.$LoadShow, true)
      this.$post("/staff/api/saveStaff", data)
        .then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success) {
            if (this.authStyle === 3) {
              realLiveAuth({
                type: '0',
                staffId: this.$store.state.loginInfo.staffId
              })
            } else {
              this.saveAuthInfo()
            }
          } else {
            this.$Toast('保存个人信息失败！')
          }
        });
    },
    switchAuthStatus() {
      let result = 0;
      if (this.$store.state.userInfo.certifyState === 2) {
        this.flowStep = 1
        result = 1;
      }
      return result;
    },
    //下一步
    next() {
      if (this.flowStep === 0) {
        if (!this.checked) {
          this.$Toast('请勾选协议！')
          return
        }
        this.staffName = this.staffName.trim()
        this.idCode = this.idCode.trim()
        let idcodeReg18 =
          /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        let idcodeReg15 =
          /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
        let idcodeReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/
        //let eMailReg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/
        let zReg = /\p{Unified_Ideograph}/u
        let eReg = /[\a-\z\A-\Z0-9\.\,\?\<\>\。\，\-\——\=\;\@\！\!\+\$]/g
        let zreg = zReg.test(this.staffName)
        let ereg = eReg.test(this.staffName)
        if (this.staffName && this.staffName.length >= 2 && zreg && !ereg) {
          if (this.idCode && idcodeReg.test(this.idCode)) {
            if (this.authStyle === 3) {
              realLiveAuth({
                type: '0',
                staffName: this.staffName,
                idCode: this.idCode
              })
            } else {
              this.saveAuthInfo()
            }
          } else {
            this.$Toast('请输入正确的身份证号！')
          }
        } else {
          this.$Toast('请输入正确真实姓名！')
        }
      } else {
        //认证成功后在不能刷新个人信息的时候修改认证状态完成状态显示
        if (this.$store.state.sourceFlag) {
          closeCurrentPage()
        } else {
          getUserInfo()
          this.$router.go(-1)
        }
      }
    },
    //选择实人认证方式
    selectAuthStyle(type) {
      this.authStyle = type
      this.showBottom = false
      switch (type) {
        case 3:
          this.authStyleText = '人脸识别认证'
          this.authStyleTips = '根据页面提示完成指定动作后进行人脸识别，并于公安部预留人像进行对比认证'
          break;
        case 4:
          this.authStyleText = '实名手机号认证'
          this.authStyleTips = '与运营商手机号实名信息对比验证，请确保手机号已通过运营商实名认证'
          break;
        case 5:
          this.authStyleText = '个人银行卡认证'
          this.authStyleTips = '与银行开户预留信息对比验证，请确保手机号为银行卡预留手机号'
          break;
      }
    },
    //跳转实人认证协议
    agreementClick() {
      this.$router.push({
        name: 'agreementdetails',
        params: {
          type: 3,
        }
      })
    },
    //返回上一步
    back() {
      switch (this.flowStep) {
        case 1:
          this.staffName = ''
          this.idCode = ''
          this.phone = ''
          this.verifyCode = ''
          this.smscode = ''
          this.backNumber = ''
          this.flowStep = 0
          break;
        case 0:
          if (this.$route.query.appCode) {
            closeCurrentPage()
          } else {
            this.$router.go(-1)
          }
          break;
      }
    },
    //获取焦点
    getFocus(index) {
      switch (index) {
        case 1:
          this.nameFocus = true
          break;
        case 2:
          this.idcodeFocus = true
          break;
        case 3:
          this.backnuFocus = true
          break;
        case 4:
          this.phoneFocus = true
          break;
        case 5:
          this.verifyFocus = true
          break;
        case 6:
          this.smscodeFocus = true
          break;
      }
    },
    //失去焦点
    onblur(index) {
      switch (index) {
        case 1:
          this.nameFocus = false
          break;
        case 2:
          this.idcodeFocus = false
          break;
        case 3:
          this.backnuFocus = false
          break;
        case 4:
          this.phoneFocus = false
          break;
        case 5:
          this.verifyFocus = false
          break;
        case 6:
          this.smscodeFocus = false
          break;
      }
    },
    makeResize() {
      //键盘弹出
      if (this.clientHeight > 0 && document.body.clientHeight < this.clientHeight) {
        this.buttonShow = false
        let bottom = document.getElementById('bottom')
        bottom && bottom.scrollIntoView()
      } else {
        this.buttonShow = true
      }
    },
    //初始化
    init() {
      getUserInfo().then(res => {
        this.getAuthInfo()
      }).catch(err => {
        this.getAuthInfo()
      })
      this.getPictureImg()
      //ios版每次使用前需要初始化
      initIosAuth()
      window.addEventListener('resize', this.resize);
      window.addEventListener('resize', this.makeResize);
    },
  },
  created() {
    //配置全局函数，实人认证结果回调函数
    window.faceAuthSucced = this.faceAuthSucced
    window.faceAuthFaild = this.faceAuthFaild
  },
  mounted() {
    this.init()
  },
  computed: {
    //获得高度
    resize() {
      if (this.clientHeight === 0) {
        this.clientHeight = document.body.clientHeight
      }
    },
  },
  beforeDestroy() { }
}
</script>

<style scoped lang="scss">
@import "../../../styles/global.css";

::v-deep .van-cell {
  padding: 0.5rem 0.2rem;
}

// ::v-deep .van-icon{
// 	width: .4rem;
// 	height: .4rem;
// 	top: -.2rem;
// }

// .selectstyle {
// 	display: inline-block;
// 	white-space: nowrap;
// 	width: 4rem;
// }

// .selectstyle::after {
// 	content: "";
// 	display: inline-block;
// 	background-image: url('../../../assets/images/u359.png');
// 	background-size: contain;
// 	width: .5rem;
// 	height: .8rem;
// 	margin-top: .4rem;
// 	margin-left: .5rem;
// content: url('../../../assets/images/u359.png');
// //content: '退';
// height: 1.2rem;
// line-height: 1.2rem;
// margin: 0 .5rem;
//}

.selectStyleList {
  position: relative;

  .style {
    height: 4rem;
    //padding-right: .5rem;
  }
}
</style>